// extracted by mini-css-extract-plugin
export var quillEditor = "_n6-1";
export var variable = "_n6-0";